import { connectCustom } from "@client/lib/misc";

import { type RootContainerProps } from "@client/content/types";
import { type FormButtonProps } from "@client/controls/Form/component";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState, Status } from "@client/types";
import { submit } from "../actions";
import { localStateSelector } from "../selectors";
import { type ContactForm } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const captionSelector = getSettingValueSelector(TargetSelector.Entity, "caption", "button");

  return (state: AppState, props: RootContainerProps & FormButtonProps): MapProps => {
    const buttonCaption = captionSelector(state, props);
    const localState = localStateSelector(state, props);

    return {
      ...props,
      isSending: localState.status === Status.Saving,
      buttonCaption
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClick: (data: ContactForm.FormData) => dispatch(submit({ id: props.id, source: props.source }, data))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
